import React, { useState } from 'react'
import { ImageMetadata } from './ImageMetadata'
import { ArrowIcon, PlayIcon } from './Icons'

export function SiteImageViewer({ image, images, onPrevImage, onNextImage, onImageClick }) {
  const [imageLoaded, setImageLoaded] = useState(false)
  
  if (!image) {
    return (
      <div className="site-image-viewer">
        <div className="site-image-viewer__empty">
          <p>No images available for this site</p>
        </div>
      </div>
    )
  }

  const isVideo = image.vimeo_id && image.vimeo_id !== ''
  const currentIndex = images.findIndex(img => img.filename === image.filename)

  return (
    <div className="site-image-viewer">
      <div className="site-image-viewer__image-container">
        <div className="site-image-viewer__image-header">
          <button 
            className="image-nav-arrow"
            onClick={onPrevImage}
            aria-label="Previous image"
          >
            <ArrowIcon className="-flip" />
          </button>

          <span className="image-counter">{currentIndex + 1} of {images.length}</span>

          <button 
            className="image-nav-arrow"
            onClick={onNextImage}
            aria-label="Next image"
          >
            <ArrowIcon />
          </button>
        </div>

        <div 
          className="site-image-viewer__image"
          onClick={() => onImageClick(image)}
        >
          {isVideo ? (
            <div className="site-image-viewer__video-placeholder">
              <img 
                src={`https://vumbnail.com/${image.vimeo_id}.jpg`}
                alt={image.filename}
                onError={(e) => {
                  e.target.style.display = 'none'
                }}
              />
              <div className="site-image-viewer__play-icon">
                <PlayIcon />
              </div>
            </div>
          ) : (
            <>
              {image.lqip && (
                <img 
                  src={image.lqip}
                  alt=""
                  className={`site-image-viewer__lqip ${imageLoaded ? '-hidden' : ''}`}
                  aria-hidden="true"
                />
              )}
              <img 
                src={`assets/expeditions-data/thumbnails/${encodeURIComponent(image.filename)}`}
                alt={image.filename}
                className={`site-image-viewer__full ${imageLoaded ? '-loaded' : ''}`}
                onLoad={() => setImageLoaded(true)}
              />
            </>
          )}
        </div>
      </div>

      <ImageMetadata item={image} />
    </div>
  )
}

